define(function (require) {
	// general
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');
	// templates
	const tpl = require('civicsViews/search_view/templates/t_lov_search_view.hbs');
	// views
	const ResultsListView = require('civicsViews/search_view/v_cpv_records_list');
	const LiveRegion = require('civicsUtils/live_region_utility');

	return Marionette.LayoutView.extend({
		initialize: function (options) {
			if (__DEV__) console.log('lov_logs -- initialize');
			this.config = options.config ? options.config : {};
			this.collection = options.collection;
			this.childView = options.childView;
			this.portletName = options.portletName;
			this.isDynamicFetch = options.isDynamicFetch;
			this.config.commonLabel = {};

			//setup the labels
			if (this.portletName && this.portletName.length > 0) {
				var localizationKey = this.portletName.toUpperCase();

				this.config.commonLabel = {
					'genericLabel': i18n.t('CIVICS.'+ localizationKey + '.GENERIC_LABEL.ABOVE_RECORD_SEARCH'),
					'searchInstruction': i18n.t('CIVICS.'+ localizationKey + '.SEARCH_INSTRUCTIONS'),
					'noRecordListMessage': i18n.t('CIVICS.'+ localizationKey + '.NO_RECORD_LIST_MESSAGE'),
					'searchPlaceHolder': i18n.t('CIVICS.'+ localizationKey + '.SEARCH_TEXTBOX_PLACEHOLDER'),
					'IDnumber' : i18n.t('CIVICS.'+ localizationKey + '.ID_NUMBER')
				}
			}

		},
		template: tpl,
		regions: {
			resultViewRegion: '@ui.results',
		},
		ui: {
			results: '.results-container',
			btnSearch: '.btn-search',
			searchBox: '.input-search-box .input-text',
			genericLabel: '.generic-label',
			resultHelpermessage: '.result-helper-message',
			resultsBox: '.results-container-box'
		},
		views: {},
		events: {
			'keyup @ui.searchBox': 'searchBoxKeyPress',
			'click @ui.btnSearch': 'searchClicked',
		},
		onRender: function () {
		},
		onShow: function () {

			if (this.config.commonLabel.genericLabel.length > 0) {
				this.ui.genericLabel.html(this.config.commonLabel.genericLabel);
			} else {
				this.ui.genericLabel.remove();
			}

			this.ui.resultsBox.hide();
		},
		searchBoxKeyPress: function (e) {
			if (e.which === 13) { // enter keyCode
				this.searchClicked(e);
			}
		},

		isSearchBoxEmpty: function() {
			return (this.ui.searchBox && this.ui.searchBox.val().trim().length === 0) ? true : false;
		},
		searchClicked: function (e) {
			e.preventDefault();
			ViewManager.resetErrorMessages(this);
			if (!this.isSearchBoxEmpty()) {
				//trigger the method in parentView and it should have -- onChildviewUpdateCollectionParam -- method for this to work.
				this.searchVal = this.ui.searchBox.val().trim();
				this.triggerMethod('update:collection:param', this);
			} else {
				var error = {};
				error.validationError = {};
				error.validationError.inputSearch= i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED', {field: this.config.commonLabel.IDnumber});

				ViewManager.errorToWindow(error, this);
			}
		},
		fetchInstrumentsList: function () {
			var self = this;

			ViewManager.loading(true);
			if(this.views.resultListView) {
				this.views.resultListView.destroy();
				this.resultViewRegion.empty();
				this.ui.resultHelpermessage.empty();
			}
			this.ui.resultsBox.hide();

			this.collection.fetch().done().always(function() {
				if (!self.isDynamicFetch) { //if you have additional fetches in your collection:fetch:done method, just add these lines manually
					self.onSearchCollectionFetchDone();
				}
				//trigger method in parentView and it should have -- onChildviewCollectionFetchDone -- method for this to work.
				//this will give the parent view the ability to do more actions based the result.
				self.triggerMethod('collection:fetch:done', this);
			});
		},
		onSearchCollectionFetchDone: function() {
			ViewManager.loading(false);
			this.ui.resultsBox.show();
			if (this.resultViewRegion && this.resultViewRegion.$el) {

				this.views.resultListView = new ResultsListView ({
					config: this.config,
					collection: this.collection,
					childView: this.childView,
				});

				this.resultViewRegion.show(this.views.resultListView);

				// Announce search result count to assistive technology
				var resultCount = this.collection.length;
				if (resultCount === 0) {
					LiveRegion.announcePolite('No search results found');
				} else {
					LiveRegion.announcePolite(resultCount + ' search results found');
				}

				this.listenTo(this.views.resultListView, "itemSelected", (value) => {
					//trigger method in parentView and it should have -- onChildviewItemSelected(model, value) -- method for this to work.
					//this will give the parent view to do more actions after the item has been selected. in your itemView, just call this.trigger('itemSelected', <parameter>);
					this.triggerMethod('item:selected', value);
				});
			}
		},
		templateHelpers: function () {
			var self = this;
			return {
				searchInstruction: self.config.commonLabel.searchInstruction,
				searchPlaceHolder: self.config.commonLabel.searchPlaceHolder
			};
		},
	});
});
